import map from 'lodash/map';
import * as FormatUtils from '@Services/FormatUtils';

/**
 * Format availability links and images urls and add access token for BE
 * @param availability
 */
// eslint-disable-next-line import/prefer-default-export
export function formatStructureAvailabilityUrls(availability) {
  if (!availability) return availability;
  return {
    ...availability,
    ...(availability.url && { url: FormatUtils.formatPath(availability.url) }),
    ...(availability.providers && {
      providers: map(availability.providers, (provider) => {
        if (provider.custom) return provider;
        return {
          ...provider,
          imageUrl: FormatUtils.formatPath(provider.imageUrl),
          linkUrl: FormatUtils.formatPath(provider.linkUrl),
        };
      }),
    }),
  };
}
